export type ClusterStatus = 'strong' | 'partial' | 'absent'

// Traffic-light thresholds (spec Global Constraints): rate >= 0.5 strong,
// 0.2 <= rate < 0.5 partial, rate < 0.2 absent.
export function clusterStatus(rate: number): ClusterStatus {
  if (rate >= 0.5) return 'strong'
  if (rate >= 0.2) return 'partial'
  return 'absent'
}

// Tailwind `fill-*` classes for SVG nodes, keyed by status.
export const statusFill: Record<ClusterStatus, string> = {
  strong: 'fill-emerald-500',
  partial: 'fill-amber-500',
  absent: 'fill-red-500',
}

// Tailwind text classes for table/labels, keyed by status.
export const statusText: Record<ClusterStatus, string> = {
  strong: 'text-emerald-600',
  partial: 'text-amber-600',
  absent: 'text-red-600',
}

// Human labels for each status.
export const statusLabel: Record<ClusterStatus, string> = {
  strong: 'Strong',
  partial: 'Partial',
  absent: 'Absent',
}
